import type { MetaDescriptor } from "@remix-run/node";

export function descriptionMeta(value: string): MetaDescriptor[] {
  return [
    { name: "description", content: value },
    { property: "og:description", content: value },
    { name: "twitter:description", content: value },
  ];
}
